<template>
  <div class="ChangePassword">
    <!-- 顶部提示 -->
    <div class="topTip">
      <label class="msg">{{ tipMsg }}</label>
    </div>
    <div class="list">
      <!-- 照片上传 -->
      <div class="module module-upload">
        <div class="upload-row" v-if="frontPics.length">
          <div class="upload-row-info">
            <div class="upload-row-title">头像面</div>
            <div class="upload-row-desc">上传您的身份证头像面</div>
          </div>
          <div class="upload-row-action">
            <div class="upload-preview">
              <div class="upload-preview-inner">
                <img :src="frontPics[0]" />
              </div>
              <span class="iconfont icon-guanbi1 font-color-red" @click.stop="delPic('front')"></span>
            </div>
          </div>
        </div>
        <div v-else class="upload-row upload-row-empty">
          <VueCoreImageUpload
            class="upload-row-uploader"
            @imageuploading="onFrontUploading"
            @imageuploaded="uploadFrontPic"
            @errorhandle="onUploadError('front', $event)"
            :crop="false"
            compress="80"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="uploadImgUrl"
          >
            <div class="upload-row-inner">
              <div class="upload-row-info">
                <div class="upload-row-title">头像面</div>
                <div class="upload-row-desc">上传您的身份证头像面</div>
              </div>
              <div class="upload-row-action">
                <div class="upload-frame">
                  <span class="corner corner-tl"></span>
                  <span class="corner corner-tr"></span>
                  <span class="corner corner-bl"></span>
                  <span class="corner corner-br"></span>
                  <svg class="upload-illus" viewBox="0 0 120 72" aria-hidden="true">
                    <rect x="10" y="14" width="52" height="6" rx="2" fill="#c5d9f5" />
                    <rect x="10" y="26" width="40" height="4" rx="2" fill="#dce8fb" />
                    <rect x="10" y="36" width="46" height="4" rx="2" fill="#dce8fb" />
                    <rect x="10" y="46" width="36" height="4" rx="2" fill="#dce8fb" />
                    <circle cx="88" cy="32" r="14" fill="#c5d9f5" />
                    <path d="M88 24c4.4 0 8 3.1 8 7s-3.6 7-8 7-8-3.1-8-7 3.6-7 8-7z" fill="#eef4ff" />
                    <path d="M74 52c2-8 8-12 14-12s12 4 14 12" fill="#c5d9f5" />
                  </svg>
                </div>
              </div>
            </div>
          </VueCoreImageUpload>
        </div>

        <div class="upload-row" v-if="backPics.length">
          <div class="upload-row-info">
            <div class="upload-row-title">国徽面</div>
            <div class="upload-row-desc">上传您的身份证国徽面</div>
          </div>
          <div class="upload-row-action">
            <div class="upload-preview">
              <div class="upload-preview-inner">
                <img :src="backPics[0]" />
              </div>
              <span class="iconfont icon-guanbi1 font-color-red" @click.stop="delPic('back')"></span>
            </div>
          </div>
        </div>
        <div v-else class="upload-row upload-row-empty">
          <VueCoreImageUpload
            class="upload-row-uploader"
            @imageuploading="onBackUploading"
            @imageuploaded="uploadBackPic"
            @errorhandle="onUploadError('back', $event)"
            :crop="false"
            compress="80"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="uploadImgUrl"
          >
            <div class="upload-row-inner">
              <div class="upload-row-info">
                <div class="upload-row-title">国徽面</div>
                <div class="upload-row-desc">上传您的身份证国徽面</div>
              </div>
              <div class="upload-row-action">
                <div class="upload-frame">
                  <span class="corner corner-tl"></span>
                  <span class="corner corner-tr"></span>
                  <span class="corner corner-bl"></span>
                  <span class="corner corner-br"></span>
                  <svg class="upload-illus" viewBox="0 0 120 72" aria-hidden="true">
                    <circle cx="34" cy="36" r="16" fill="#ffd6d6" />
                    <circle cx="34" cy="36" r="10" fill="#ff6b6b" />
                    <rect x="58" y="18" width="46" height="5" rx="2" fill="#c5d9f5" />
                    <rect x="58" y="30" width="52" height="4" rx="2" fill="#dce8fb" />
                    <rect x="58" y="40" width="48" height="4" rx="2" fill="#dce8fb" />
                    <rect x="58" y="50" width="40" height="4" rx="2" fill="#dce8fb" />
                  </svg>
                </div>
              </div>
            </div>
          </VueCoreImageUpload>
          <div
            v-if="backUploading"
            class="upload-row-mask acea-row row-center-wrapper row-column"
          >
            <span class="uploading-spinner"></span>
            <div>上传中...</div>
          </div>
        </div>

        <div class="upload-row upload-row-last" v-if="selfPics.length">
          <div class="upload-row-info">
            <div class="upload-row-title">自拍照</div>
            <div class="upload-row-desc">上传您的清晰自拍照</div>
          </div>
          <div class="upload-row-action">
            <div class="upload-preview">
              <div class="upload-preview-inner">
                <img :src="selfPics[0]" />
              </div>
              <span class="iconfont icon-guanbi1 font-color-red" @click.stop="delPic('self')"></span>
            </div>
          </div>
        </div>
        <div v-else class="upload-row upload-row-empty upload-row-last">
          <VueCoreImageUpload
            class="upload-row-uploader"
            @imageuploading="onSelfUploading"
            @imageuploaded="uploadSelfPic"
            @errorhandle="onUploadError('self', $event)"
            :crop="false"
            compress="80"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="uploadImgUrl"
          >
            <div class="upload-row-inner">
              <div class="upload-row-info">
                <div class="upload-row-title">自拍照</div>
                <div class="upload-row-desc">上传您的清晰自拍照</div>
              </div>
              <div class="upload-row-action">
                <div class="upload-frame">
                  <span class="corner corner-tl"></span>
                  <span class="corner corner-tr"></span>
                  <span class="corner corner-bl"></span>
                  <span class="corner corner-br"></span>
                  <svg class="upload-illus upload-illus-self" viewBox="0 0 120 72" aria-hidden="true">
                    <circle cx="60" cy="28" r="12" fill="#c5d9f5" />
                    <path d="M38 58c4-10 12-16 22-16s18 6 22 16" fill="#c5d9f5" />
                    <rect x="46" y="52" width="28" height="4" rx="2" fill="#dce8fb" />
                  </svg>
                </div>
              </div>
            </div>
          </VueCoreImageUpload>
          <div
            v-if="selfUploading"
            class="upload-row-mask acea-row row-center-wrapper row-column"
          >
            <span class="uploading-spinner"></span>
            <div>上传中...</div>
          </div>
        </div>
      </div>

      <!-- 姓名、身份证号 -->
      <div class="module">
        <div class="item">
          <label class="item-name">姓名</label>
          <input type="text" placeholder="上传身份证后自动识别" v-model="name" disabled class="placeholder" />
        </div>
        <div class="item item-last">
          <label class="item-name">身份证号</label>
          <input type="text" placeholder="上传身份证后自动识别" v-model="idNo" disabled class="placeholder" />
        </div>
      </div>

      <!-- 手机号、验证码 -->
      <div class="module">
        <div class="item" :class="{ 'item-last': notEditable && !isShowCode }">
          <div class="item-name">手机号码</div>
          <input type="number" placeholder="请填写你本人手机号码" v-model="phone" :disabled="notEditableForPhone"
            class="placeholder" />
        </div>
        <div class="item" v-if="!notEditable" :class="{ 'item-last': !isShowCode }">
          <div class="item-name">验证码</div>
          <input type="text" placeholder="填写验证码" class="codeIput" v-model="captcha" />
          <button class="code font-color-red" :disabled="disabled" :class="disabled === true ? 'on' : ''"
            @click="sendSMSCode">
            {{ text }}</button>
        </div>
        <div class="item item-last" v-if="isShowCode">
          <div class="item-name">图形验证</div>
          <input type="text" placeholder="填写验证码" class="codeIput" v-model="codeVal" />
          <div class="codeVal" @click="imagesCodeTap"><img :src="codeUrl" /></div>
        </div>
      </div>
    </div>
    <div class="confirmBnt bg-color-red" @click="submitRealName">{{btnText}}</div>
    <!-- <div class="addConstomerBtn" @click="$router.push({ path: '/news_detail/1'})">{{addConstomerBtnText}}</div> -->
    <div style="height: 1rem;"></div>
    <div
      v-if="frontUploading"
      class="page-loading-mask acea-row row-center-wrapper row-column"
      @touchmove.prevent
      @click.prevent
    >
      <div class="page-loading-box acea-row row-center-wrapper row-column">
        <span class="page-loading-spinner"></span>
        <div class="page-loading-text">{{ frontLoadingText }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import attrs, { required, alpha_num, chs_phone, chs, idNoValid } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { registerVerify, bindingPhone, getCodeApi, realNameAuth, idCardOcrResult } from "@api/user";
import { VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";

export default {
  name: "BindingPhone",
  components: {
    VueCoreImageUpload
  },
  props: {},
  data: function () {
    return {
      uploadImgUrl: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      tipMsg: '',
      name: "",
      idNo: "",
      address: "",
      phone: "", //手机号
      captcha: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false,
      
      notEditable: false,

      frontPics: [],
      backPics: [],
      selfPics: [],
      frontUploading: false,
      frontLoadingText: "上传中...",
      backUploading: false,
      selfUploading: false,
      authUrl: '',
      btnText: '下一步',
      addConstomerBtnText: ''

    };
  },
  mixins: [sendVerifyCode],
  computed: {
    ...mapGetters(["userInfo"]),
    isImageUploading() {
      return this.frontUploading || this.backUploading || this.selfUploading;
    }
  },
  mounted: function () {
    this.getKeyCode();
    this.initData();
  },
  methods: {
    initData() {
      let userInfo = this.userInfo;
      this.notEditable = (userInfo.auth_status == 1 || userInfo.auth_status == 2); //待审核和已认证，不可以编辑
      this.notEditableForPhone = this.notEditable;
      this.btnText = this.notEditable ? '查看个人信息授权书' : '下一步';
      var tipMsg = '';
      var addConstomerBtnText = '';
      if (userInfo.auth_status == 0) {
        tipMsg = '请正确填写信息，您的隐私数据会得到有效保护。';
        addConstomerBtnText = '添加客服企业微信，加速审核';
      } else if (userInfo.auth_status == 1) {
        tipMsg = '您的认证信息已提交，请耐心等待审核结果。';
        addConstomerBtnText = '添加客服企业微信，加速审核';
      } else if (userInfo.auth_status == 2) {
        tipMsg = '恭喜，您的认证信息已通过审核。';
        addConstomerBtnText = '添加客服企业微信';
      } else if (userInfo.auth_status == 3) {
        tipMsg = '您的认证信息未通过审核，请重新填写并提交。';
        addConstomerBtnText = '添加客服企业微信，了解更多';
      }
      this.tipMsg = tipMsg;
      this.addConstomerBtnText = addConstomerBtnText;

      if (userInfo.auth_status > 0) {
        this.name = userInfo.real_name;
        this.phone = userInfo.phone;
        this.idNo = userInfo.card_id;
        this.address = (userInfo.addres || "").replace(/\[#]/g, "");
        this.frontPics = [userInfo.card_img_front];
        this.backPics = [userInfo.card_img_back];
        this.selfPics = [userInfo.self_img];
      }
      else {
        // setTimeout(() => {
        //   this.$dialog.alert({
        //     mes: '为了快速获得购买资格，请确保本人认证评估！'
        //   }, () => { });
        // }, 500);
        if(userInfo.phone) {
          this.phone = userInfo.phone;
          this.notEditableForPhone = true;
        }
      }

      if (userInfo.auth_status == 0 && !this.$route.query.redirect) {
        this.$nextTick(() => {
          this.$dialog.confirm({
            mes: "请通过审核专用链接提交材料。",
            title: "温馨提示",
            opts: [
              {
                txt: "取消",
                color: false,
                callback: () => {
                  this.$router.go(-1);
                }
              },
              {
                txt: "好的",
                color: true,
                callback: () => {
                  this.$router.replace({ path: "/deposit/60" });
                }
              }
            ]
          });
        });
      }
    },
    onFrontUploading() {
      this.frontLoadingText = "上传中...";
      this.frontUploading = true;
    },
    onBackUploading() {
      this.backUploading = true;
    },
    onSelfUploading() {
      this.selfUploading = true;
    },
    finishUpload(type) {
      if (type === "front") {
        this.frontUploading = false;
      } else if (type === "back") {
        this.backUploading = false;
      } else {
        this.selfUploading = false;
      }
    },
    onUploadError(type, err) {
      this.finishUpload(type);
      this.$dialog.error(err || "上传图片失败");
    },
    uploadFrontPic(res) {
      if (!res || res.status !== 200 || !res.data || !res.data.url) {
        this.finishUpload("front");
        return this.$dialog.error((res && res.msg) || "上传图片失败");
      }
      const url = res.data.url;
      this.frontPics.push(url);
      this.frontLoadingText = "识别中...";
      this.fetchIdCardOcr(url);
    },
    fetchIdCardOcr(idCardUrl) {
      if (this.notEditable) {
        this.finishUpload("front");
        return;
      }
      idCardOcrResult({ idCardUrl })
        .then(res => {
          const data = res.data || {};
          this.name = data.realname || "";
          this.idNo = data.idcard || "";
          this.address = data.address || "";
          if (!this.name || !this.idNo) {
            this.frontPics = [];
            this.address = "";
            this.$dialog.error("身份证识别失败，请重新上传");
          }
        })
        .catch(err => {
          this.frontPics = [];
          this.name = "";
          this.idNo = "";
          this.address = "";
          this.$dialog.error(err.msg || "身份证识别失败，请重新上传");
        })
        .finally(() => {
          this.finishUpload("front");
        });
    },
    uploadBackPic(res) {
      this.finishUpload("back");
      if (!res || res.status !== 200) {
        return this.$dialog.error(res.msg || "上传图片失败");
      }
      this.backPics.push(res.data.url);
    },
    uploadSelfPic(res) {
      this.finishUpload("self");
      if (!res || res.status !== 200) {
        return this.$dialog.error(res.msg || "上传图片失败");
      }
      this.selfPics.push(res.data.url);
    },
    delPic(type) {
      if(this.notEditable) {
        return this.$dialog.toast({ mes: "当前状态不支持编辑" });
      }
      if(type === 'front') {
        this.frontPics = [];
        this.name = "";
        this.idNo = "";
        this.address = "";
      } else if(type === 'back') {
        this.backPics = [];
      } else {
        this.selfPics = [];
      }
    },
    imagesCodeTap() {
      this.codeUrl =
        VUE_APP_API_URL + "/captcha?" + this.keyCode + Date.parse(new Date());
    },
    getKeyCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    
    async submitRealName() {
      if (this.notEditable) {
        this.$router.push({
          path: "/user/auth_statement",
        });
        return;
      }
      if (this.isImageUploading) {
        return this.$dialog.toast({ mes: "稍等，图片上传中" });
      }

      let that = this;
      const { name, idNo, phone, captcha, frontPics, backPics, selfPics } = that;
      try {
        await that
          .$validator({
            frontPics: [
              { validator(rule, value, callback) {
                if(!value || value.length == 0) {
                  callback(new Error('请上传身份证正面照片'));
                } else {
                  callback();
                }
              } }
            ],
            backPics: [
              { validator(rule, value, callback) {
                if(!value || value.length == 0) {
                  callback(new Error('请上传身份证反面照片'));
                } else {
                  callback();
                }
              } }
            ],
            selfPics: [
              { validator(rule, value, callback) {
                if(!value || value.length == 0) {
                  callback(new Error('请上传清晰自拍照片'));
                } else {
                  callback();
                }
              } }
            ],
            name: [
              required("请先上传身份证识别姓名"),
              chs(chs.message('姓名'))
            ],
            idNo: [
              required("请先上传身份证识别身份证号"),
              idNoValid()
            ],
            phone: [
              required(required.message("本人手机号码")),
              chs_phone(chs_phone.message("本人手机号码")),
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ name, idNo, phone, captcha, frontPics, backPics, selfPics });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      let paramData = {
        name: this.name,
        cardId: this.idNo,
        phone: this.phone,
        captcha: this.captcha,
        address: this.address,
        cardImgFront: this.frontPics[0],
        cardImgBack: this.backPics[0],
        emergencyContract: "",
        selfPicImg: this.selfPics[0],
        isPreCheck: true,
        location: ""
      };
      realNameAuth(paramData).then(res => {
        paramData.isPreCheck = false;
        const query = { ...paramData };
        if (that.$route.query.redirect) {
          query.redirect = that.$route.query.redirect;
        }
        that.$router.push({
          path: "/user/auth_statement",
          query
        });
      }).catch(err => {
        that.$dialog.error(err.msg || "提交失败");
      });
    },
    async sendSMSCode() {
      let that = this;
      const { phone } = that;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("本人手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      registerVerify({ phone: phone, key: that.keyCode, code: that.codeVal })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>
<style scoped>
.ChangePassword {
  border-top: 1px solid #f0f0f0;
  background-color: rgb(245, 245, 245) !important;
  min-height: 100vh;
}

.ChangePassword .topTip {
  width: 100%;
  height: 0.60rem;
  background-color: #E98856;
  display: flex;
  align-items: center;
  padding-left: 0.50rem;
}

.ChangePassword .topTip .msg {
  color: white;
}

.ChangePassword .list {
  width: 100%;
  margin: 0 auto;
  /* padding: 0 0.5rem; */
}

.ChangePassword .list .module {
  background-color: #fff;
  margin-top: 0.13rem;
  padding: 0 0.5rem;
  overflow: hidden;
}

.ChangePassword .list .module-upload {
  padding: 0.28rem 0.3rem 0.32rem;
  overflow: visible;
}

.ChangePassword .list .item.item-last {
  border-bottom: none;
}

.ChangePassword .list .item-tile {
  width: 100%;
  height: 1.10rem;
  border-bottom: 0.02rem solid #f0f0f0;
  display: flex;
  justify-content: left;
  align-items: left;
  padding-left: 0.1rem;
}

.ChangePassword .list .item-tile .item-tile-name {
  width: 50%;
  text-align: left;
  height: 100%;
  line-height: 1.10rem;
  font-size: 0.34rem;
  font-weight: 500;
}

.ChangePassword .list .item {
  width: 100%;
  height: 1.10rem;
  border-bottom: 0.02rem solid #f0f0f0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 0.1rem;
}

.ChangePassword .list .item .item-name {
  width: 2.5rem;
  text-align: left;
  height: 100%;
  line-height: 1.10rem;
  font-size: 0.32rem;
}

.ChangePassword .list .item input {
  /* width: 75%; */
  height: 100%;
  font-size: 0.32rem;
  font-weight: normal;
  color: #000;
  border: none;
  outline: none;
}

.ChangePassword .list .item .picker {
  /* width: 60%; */
  height: 100%;
  font-size: 0.32rem;
  font-weight: normal;
  color: #000;
  border: none;
  outline: none;
  align-items: center;
}

.ChangePassword .list .item .placeholder {
  /* color: #b9b9bc; */
  font-size: 0.32rem;
  /* font-weight: 300; */
}

.ChangePassword .list .item input.codeIput {
  width: 2.50rem;
}

.ChangePassword .list .item .code {
  font-size: 0.32rem;
  background-color: #fff;
  /* border: 0.01rem solid #3E3841; */
  height: 100%;
  width: 3rem;
}

.ChangePassword .list .item .codeVal {
  width: 3rem;
  height: 0.6rem;
}

.ChangePassword .list .item .codeVal img {
  width: 100%;
  height: 100%;
}

.ChangePassword .list .item .code.on {
  color: #b9b9bc !important;
  border-color: #b9b9bc;
}

.ChangePassword .list .item .images {
  width: 1.60rem;
  height: 0.70rem;
  display: block;
}

.module-upload .upload-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.28rem 0.24rem;
  margin-bottom: 0.2rem;
  background: #f7f8fa;
  border-radius: 0.16rem;
}

.module-upload .upload-row-empty {
  position: relative;
  padding: 0;
  cursor: pointer;
}

.module-upload .upload-row-uploader {
  width: 100%;
  display: block;
}

.module-upload .upload-row-uploader ::v-deep .g-core-image-upload-btn {
  width: 100%;
  display: block;
}

.module-upload .upload-row-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.28rem 0.24rem;
}

.module-upload .upload-row-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  background: rgba(247, 248, 250, 0.92);
  border-radius: 0.16rem;
  color: #999;
  font-size: 0.22rem;
  pointer-events: none;
}

.module-upload .upload-row-last {
  margin-bottom: 0;
}

.module-upload .upload-row-info {
  flex: 1;
  min-width: 0;
  padding-right: 0.2rem;
}

.module-upload .upload-row-title {
  font-size: 0.34rem;
  color: #282828;
  font-weight: 600;
  line-height: 1.3;
}

.module-upload .upload-row-desc {
  margin-top: 0.12rem;
  font-size: 0.24rem;
  color: #999;
  line-height: 1.4;
}

.module-upload .upload-row-action {
  flex-shrink: 0;
  overflow: visible;
}

.module-upload .upload-preview {
  position: relative;
  width: 2.56rem;
  height: 1.56rem;
  overflow: visible;
}

.module-upload .upload-frame {
  position: relative;
  width: 2.56rem;
  height: 1.56rem;
  background: #eef4ff;
  border: 1px solid #c5d9f5;
  border-radius: 0.1rem;
  box-sizing: border-box;
  overflow: hidden;
}

.module-upload .upload-illus {
  width: 100%;
  height: 100%;
  display: block;
}

.module-upload .corner {
  position: absolute;
  width: 0.18rem;
  height: 0.18rem;
  border-color: #4a90e2;
  border-style: solid;
  z-index: 1;
}

.module-upload .corner-tl {
  top: 0.08rem;
  left: 0.08rem;
  border-width: 0.04rem 0 0 0.04rem;
}

.module-upload .corner-tr {
  top: 0.08rem;
  right: 0.08rem;
  border-width: 0.04rem 0.04rem 0 0;
}

.module-upload .corner-bl {
  bottom: 0.08rem;
  left: 0.08rem;
  border-width: 0 0 0.04rem 0.04rem;
}

.module-upload .corner-br {
  bottom: 0.08rem;
  right: 0.08rem;
  border-width: 0 0.04rem 0.04rem 0;
}

.module-upload .upload-preview {
  border-radius: 0.1rem;
  background-color: #eef4ff;
  border: 1px solid #c5d9f5;
  box-sizing: border-box;
}

.module-upload .upload-preview-inner {
  width: 100%;
  height: 100%;
  border-radius: 0.08rem;
  overflow: hidden;
}

.module-upload .upload-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.module-upload .upload-preview .icon-guanbi1 {
  position: absolute;
  top: -0.1rem;
  right: -0.1rem;
  font-size: 0.36rem;
  z-index: 3;
  background: #fff;
  border-radius: 50%;
  line-height: 1;
  box-shadow: 0 0.02rem 0.08rem rgba(0, 0, 0, 0.12);
}

.module-upload .uploading-spinner {
  width: 0.4rem;
  height: 0.4rem;
  margin-bottom: 0.12rem;
  border: 0.04rem solid #e5e5e5;
  border-top-color: #4a90e2;
  border-radius: 50%;
  animation: binding-phone-upload-spin 0.8s linear infinite;
}

@keyframes binding-phone-upload-spin {
  to {
    transform: rotate(360deg);
  }
}

.ChangePassword .confirmBnt {
  font-size: 0.32rem;
  width: 5.80rem;
  height: 0.90rem;
  border-radius: 0.45rem;
  color: #fff;
  margin: 0.92rem auto 0;
  text-align: center;
  line-height: 0.90rem;
  border: none;
  background-color: #007aff; /* 示例颜色 */
}

.ChangePassword .addConstomerBtn {
  font-size: 0.32rem;
  width: 5.80rem;
  height: 0.90rem;
  border-radius: 0.45rem;
  color: #E93323;
  margin: 0.60rem auto 0;
  text-align: center;
  line-height: 0.90rem;
  border: 1px solid #E93323;
  background-color: #fff;
}

.ChangePassword .bottom-padding {
  height: 1rem;
}

.page-loading-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.45);
}

.page-loading-box {
  min-width: 2.4rem;
  padding: 0.36rem 0.48rem;
  background: #fff;
  border-radius: 0.16rem;
  box-shadow: 0 0.08rem 0.24rem rgba(0, 0, 0, 0.12);
}

.page-loading-spinner {
  width: 0.48rem;
  height: 0.48rem;
  margin-bottom: 0.16rem;
  border: 0.04rem solid #e5e5e5;
  border-top-color: #e93323;
  border-radius: 50%;
  animation: binding-phone-upload-spin 0.8s linear infinite;
}

.page-loading-text {
  font-size: 0.28rem;
  color: #666;
  line-height: 1.4;
}


</style>
